import Vue from 'vue'
import request from '@/request'
import { uploadConfig, upload } from '@/api.js'
class Upload {
  constructor() {
    this.chunkSize = 0
    this.fileInfo = {
      raw: null,
      size: 0,
      name: '',
      filename: '',
      md5: ''
    }
    this.fileObj = {}
    this.complete = null
    this.reject = null
    this.config = {}
    this.loading = null
  }

  async start(file) {
    // 入口方法，读取配置，计算md5，并开始上传
    // file: size, name, filename
    this.fileObj = {}
    this.fileObj = file
    const { raw, size, name = '', filename, type = undefined } = file
    Object.assign(this.fileInfo, {raw, size, name, filename, type})
    return new Promise((resolve, reject) => {
      this.complete = resolve
      this.reject = reject
      this.computeMD5()
    })
  }

  getConfig() {
    // 获取配置
    const { md5, name, size, filename, type } = this.fileInfo
    const info = {
      file_md5: md5,
      name,
      file_size: size,
      filename,
      type
    }
    
    return request('post', uploadConfig, info, { silence: true })
    .then((res) => {
      if (res) {
        const data = res

        if (data.file_exist) {
          const info = {
            fileId: data.info.id,
            fileUrl: data.info.url,
            filePath: data.info.path
          }
          this.fileObj.percentage = 1

          this.complete(info)
          return false
        } else {
          if (Number(data.info.is_finished) === 0) {
            this.config = {
              chunkSize: data.info.per_slice,
              lastPiece: data.info.last_slice_number,
              fileId: data.info.id
            }

            return true
          }
        }
      } else {
        return false
      }
    })
  }

  computeMD5 () {
    // 计算md5
    const chunkSize = 1024 * 20 * 1
    // this.fileInfo.file = file
    const file = this.fileInfo.raw
    const reader = new FileReader()
    const chunks = Math.ceil(this.fileInfo.size / chunkSize)
    const spark = new Vue.prototype.$md5.ArrayBuffer()
    const blobSlice =
      File.prototype.slice ||
      File.prototype.mozSlice ||
      File.prototype.webkitSlice
    this.openLoading('计算中...')
    let currentChunk = 0
    reader.onload = async (e) => {
      spark.append(e.target.result)
      currentChunk++
      if (currentChunk < chunks) {
        this.loadNext(currentChunk, chunkSize, reader, blobSlice, file)
      } else {
        this.closeLoading()
        this.fileInfo.md5 = spark.end()
        const getConfigSuccess = await this.getConfig()
        if (getConfigSuccess) {
          this.startUpload(file)
        } else {
          this.reject(new Error('上传出错'))
        }
      }
    }
    reader.onerror = function() {
      console.error('md5 error')
    }
    this.loadNext(currentChunk, chunkSize, reader, blobSlice, file)
  }
  
  loadNext (current, size, reader, blob, file) {
    // 加载下一片
    const start = current * size
    const end = start + size >= file.size ? file.size : start + size
    reader.readAsArrayBuffer(blob.call(file, start, end))
  }

  async startUpload(file) {
    // 开始上传
    const fileSize = this.fileInfo.size
    const { lastPiece, chunkSize} = this.config
    const total = Math.ceil(fileSize / chunkSize)
    let i = lastPiece + 1
    let start = i*chunkSize
    let end = 0
    this.openLoading('上传中...')
    while(i < total) {
      end = start + chunkSize
      if (end >= fileSize) {
        end = fileSize
      }
      const piece = file.slice(start, end)
      await this.send(file, piece, start, end, i)
      start = end
      i ++
      this.fileObj.percentage = i/total
    }
  }

  openLoading(msg) {
    this.closeLoading()
    this.loading = this.loading || Vue.prototype.$loading({
      lock: true,
      text: msg,
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }

  closeLoading() {
    if (this.loading) {
      this.loading.close()
      this.loading = null
    }
  }

  send(file, piece, start, end, index) {
    // 提交切片数据
    const fileData = {
      file, piece, start, end, id: index
    }

    const formData = new FormData()
    formData.append("slice_file", piece)
    formData.append("slice_id", fileData.id)
    formData.append("file_id", this.config.fileId)
    return request('post', upload, formData, { silence: true })
    .then((res) => {
      if (res) {
        // 判断完成的情况，回传文件信息
        const data = res
        if (!data.continue) {
          this.fileObj.percentage = 1
          const info = {
            fileId: data.file_id,
            fileUrl: data.url,
            filePath: data.path
          }

          this.complete(info)
          this.closeLoading()
        }
      }
    })
  }
}

export default new Upload()